import { render } from "./informIcon.vue?vue&type=template&id=b8684e12"
import script from "./informIcon.vue?vue&type=script&lang=js"
export * from "./informIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__